import React from "react";
import { Grid } from "@material-ui/core";
import ExerciseSaleHeader from "../ExerciseSaleHeader";
import TicketButtonSet from "../../TicketPage/TicketButtonSet";
import { Assort } from "../../../models/Assort";
import LoadableComponent from "../../../shared/Loading/LoadableComponent";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { TicketBillLine } from "../../../models/TicketBillLine";
import { Exercise } from "../../../models/Exercise";
import { TicketAccess } from "../../../models/TicketAccess";
import getId from "../../../utils/getId";
import Navigator from "../../../shared/Navigator";
import Hidden from "@material-ui/core/Hidden";

interface IProps {
  loading: boolean;
  ticketList: { tickets: Assort[] }[];
  lengthStepper: number;
  activeStep: number;
  setActiveStep: (value: number) => void;
  addTicket: (ticket: TicketBillLine) => void;
}

const getTicketLine = (assort: Assort, exercise: Exercise) => {
  return {
    assort,
    quantity: 1,
    ticketAccessList: [{ exercise, status: "Added" } as TicketAccess],
    tempId: `${getId(exercise)}`,
  } as TicketBillLine;
};

const ExerciseSaleTicket: React.FC<IProps> = ({
  loading,
  ticketList,
  lengthStepper,
  activeStep,
  setActiveStep,
  addTicket,
}: IProps) => {
  const exerciseSelected = useSelector((state: State) => state.basket.exerciseSelect);
  return (
    <React.Fragment>
      <LoadableComponent loading={loading}>
        <div>
          {exerciseSelected.map((item, index) => (
            <Grid key={index} container spacing={4}>
              <Grid item xs={12}>
                <ExerciseSaleHeader
                  name={item.name}
                  startDate={new Date(item.startTime)}
                  endDate={new Date(item.closeTime)}
                />
              </Grid>
              <Grid container item xs={12} spacing={2}>
                {ticketList[index]?.tickets.map((assort, indexA) => (
                  <React.Fragment key={indexA}>
                    <Hidden mdDown>
                      <Grid item xs={3}>
                        <TicketButtonSet
                          key={indexA}
                          ticket={assort}
                          onBtnClick={(assort: Assort) => addTicket(getTicketLine(assort, item))}
                        />
                      </Grid>
                    </Hidden>
                    <Hidden lgUp>
                      <Grid item xs={12}>
                        <TicketButtonSet
                          key={indexA}
                          ticket={assort}
                          onBtnClick={(assort: Assort) => addTicket(getTicketLine(assort, item))}
                        />
                      </Grid>
                    </Hidden>
                  </React.Fragment>
                ))}
              </Grid>
            </Grid>
          ))}
        </div>
      </LoadableComponent>
      <Navigator
        lengthStepper={lengthStepper}
        activeStep={activeStep}
        onClickNext={() => setActiveStep(activeStep + 1)}
        onClickPrev={() => setActiveStep(activeStep - 1)}
      ></Navigator>
    </React.Fragment>
  );
};

export default ExerciseSaleTicket;
